import React, { useState } from 'react';
import { Link, NavLink } from 'react-router-dom';
import { brand } from '../config/brand';
import betaExpressLogo from '../Navbar/components/media/Logo-HD.png';
import { useLanguage } from '../i18n/LanguageContext';
import { languageOptions } from '../i18n/translations';

const navClassName = ({ isActive }) => `nav-link${isActive ? ' nav-link--active' : ''}`;

function Header() {
  const [menuOpen, setMenuOpen] = useState(false);
  const { language, setLanguage, t } = useLanguage();
  const closeMenu = () => setMenuOpen(false);

  return (
    <header className="site-header">
      <div className="site-header__inner shell">
        <Link to="/" className="brand-link" onClick={closeMenu} aria-label={t.header.homeLabel}>
          <img src={betaExpressLogo} alt="Beta Express" className="brand-logo" />
        </Link>

        <button
          className={`menu-toggle${menuOpen ? ' menu-toggle--open' : ''}`}
          type="button"
          aria-label={menuOpen ? t.header.closeMenu : t.header.openMenu}
          aria-expanded={menuOpen}
          onClick={() => setMenuOpen((value) => !value)}
        >
          <span />
          <span />
          <span />
        </button>

        <nav className={`main-nav${menuOpen ? ' main-nav--open' : ''}`} aria-label={t.header.navigationLabel}>
          <NavLink to="/" end className={navClassName} onClick={closeMenu}>{t.common.home}</NavLink>
          <NavLink to="/tracking" className={navClassName} onClick={closeMenu}>{t.common.tracking}</NavLink>
          <NavLink to="/services" className={navClassName} onClick={closeMenu}>{t.common.services}</NavLink>
          <NavLink to="/contacts" className={navClassName} onClick={closeMenu}>{t.common.contacts}</NavLink>
          <a className="button button--cabinet nav-cabinet" href={brand.cabinetUrl} target="_blank" rel="noreferrer" onClick={closeMenu}>
            {t.common.cabinet} <span aria-hidden="true">↗</span>
          </a>
          <div className="language-switcher" role="group" aria-label={t.header.languageLabel}>
            {languageOptions.map((option) => (
              <button
                key={option.code}
                type="button"
                className={language === option.code ? 'language-switcher__button language-switcher__button--active' : 'language-switcher__button'}
                onClick={() => setLanguage(option.code)}
                aria-pressed={language === option.code}
                title={option.name}
              >
                {option.label}
              </button>
            ))}
          </div>
        </nav>
      </div>
    </header>
  );
}

export default Header;
